import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';

import UpdateBankEEForm from '../Components/UpdateBankEEForm';

export default function UpdateBankEmployeePage() {


  return (
    <Box>
      <Container>
        <UpdateBankEEForm/>
      </Container>
    </Box>
  )
}
